var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useEffectOnce } from '../useEffectOnce/useEffectOnce';
import { useUpdatedRef } from '../useUpdatedRef/useUpdatedRef';
export const useUnmount = (cleanupCallback) => {
    _react_refresh_temp_1();
    const updatedCleanupCallback = useUpdatedRef(cleanupCallback);
    useEffectOnce(() => {
        return updatedCleanupCallback.current;
    });
};
_react_refresh_temp_1(useUnmount, "CgN4YZLoOBvLx2nAswywA1NnQhU=", false, () => [useUpdatedRef, useEffectOnce]);
